import { ContentType } from '../constants/contentTypes';
import {
  MCQPayload,
  TrueFalsePayload,
  SelectMultiplePayload,
  ExplanationPayload,
  CommonMistakePayload,
  TipsTricksPayload,
  ExampleQAPayload
} from '../types/content';

export const validateMCQ = (payload: MCQPayload): boolean => {
  return !!(
    payload.question &&
    Array.isArray(payload.options) &&
    payload.options.length >= 2 &&
    payload.correct_answer &&
    payload.explanation &&
    payload.options.includes(payload.correct_answer)
  );
};

export const validateTrueFalse = (payload: TrueFalsePayload): boolean => {
  return !!(
    payload.statement &&
    typeof payload.answer === 'boolean' &&
    payload.explanation
  );
};

export const validateSelectMultiple = (payload: SelectMultiplePayload): boolean => {
  return !!(
    payload.question &&
    Array.isArray(payload.options) &&
    Array.isArray(payload.correct_answers) &&
    payload.options.length >= 2 &&
    payload.correct_answers.length >= 1 &&
    payload.explanation &&
    payload.correct_answers.every(answer => payload.options.includes(answer))
  );
};

export const validateExplanation = (payload: ExplanationPayload): boolean => {
  return !!payload.explanation;
};

export const validateCommonMistake = (payload: CommonMistakePayload): boolean => {
  return !!(payload.mistake && payload.explanation);
};

export const validateTipsTricks = (payload: TipsTricksPayload): boolean => {
  return !!(Array.isArray(payload.tips) && payload.tips.length >= 1);
};

export const validateExampleQA = (payload: ExampleQAPayload): boolean => {
  return !!(payload.question && payload.answer && payload.explanation);
};

export const contentValidators = {
  [ContentType.MCQ]: validateMCQ,
  [ContentType.TRUE_FALSE]: validateTrueFalse,
  [ContentType.SELECT_MULTIPLE]: validateSelectMultiple,
  [ContentType.EXPLANATION]: validateExplanation,
  [ContentType.COMMON_MISTAKES]: validateCommonMistake,
  [ContentType.TIPS_TRICKS]: validateTipsTricks,
  [ContentType.EXAMPLE_QA]: validateExampleQA,
};